import React from 'react'
import useEffect from 'admin/hooks/useEffect'
import {flashVar, flashStackVar} from 'admin/lib/flash'
import {useReactiveVar, makeVar} from '@apollo/client'
import {useLocation} from 'react-router-dom'

export default ({floating = false, flashId}) => {
  const flash = useReactiveVar(flashVar)
  const flashStack = useReactiveVar(flashStackVar)

  useEffect(() => {
    if (flashId) {
      flashStackVar([...flashStackVar(), flashId])

      return () => {
        flashStackVar(flashStackVar().filter(id => id !== flashId))
      }
    }
  }, [])

  useEffect(() => {
    if (!floating && flash.message) window.scroll({top: 0, left: 0, behavior: 'smooth'})
  }, [flash.message])

  if (!flash.message) return null

  if (flashId && flashId !== flashStack[flashStack.length - 1]) return null
  if (!flashId && flashStack.length > 0) return null

  return (
    <section className={`section flash ${flash.type} ${floating ? 'floating' : ''}`}>
      <div className='container'>{flash.message}</div>
    </section>
  )
}
